import type React from 'react';

import { FormSpy } from 'react-final-form';

import { Alert } from '@change/ds-core-ui';

import { useFormI18n } from 'src/app/shared/form/hooks';
import type { I18nFieldValidatorResult } from 'src/app/shared/form/validators';

type Props = Readonly<{ error: I18nFieldValidatorResult }>;

const FormErrorMessage: React.FC<Props> = ({ error }) => {
	const { getErrorMessage } = useFormI18n();

	return (
		<Alert variant="error" className="mb-4">
			{getErrorMessage(error)}
		</Alert>
	);
};

export const FormError: React.FC = () => {
	return (
		<FormSpy subscription={{ submitError: true, submitting: true }}>
			{({ submitError, submitting }) =>
				/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ submitError && !submitting ? (
					<FormErrorMessage error={submitError} />
				) : null
			}
		</FormSpy>
	);
};
